import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { for: "roleId" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { for: "canManage" }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { for: "canEdit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.UserManagement.Role')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "roleId",
        modelValue: _ctx.value.roleId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.roleId) = $event)),
        options: _ctx.allRoles,
        optionValue: "id",
        optionLabel: "description",
        class: _normalizeClass({'p-invalid':_ctx.v$.roleId.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        filter: true,
        autoFilterFocus: true,
        disabled: _ctx.dialogMode === 'edit',
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "class", "onChange", "disabled", "onShow"]),
      ((_ctx.v$.roleId.$invalid && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.UserManagement.Role')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.MasterData.TableManage')), 1),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_Checkbox, {
        id: "canManage",
        modelValue: _ctx.value.canManage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.canManage) = $event)),
        binary: true,
        onChange: _ctx.update
      }, null, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.MasterData.EditData')), 1),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_Checkbox, {
        id: "canEdit",
        modelValue: _ctx.value.canEdit,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.canEdit) = $event)),
        binary: true,
        onChange: _ctx.update
      }, null, 8, ["modelValue", "onChange"])
    ])
  ]))
}